import { useAzureAuthScreenRedirect } from '../../context/AzureAuth';

// ────────────────────────────────────────────────────────────────────────────────

export const JoinScreen = () => {
  useAzureAuthScreenRedirect();

  return null;
};
